import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { ReportResponse } from "../../responses/orchestrator-patient/report.response";
import { MedicalCareReportRequest } from "../../requests/orchestrator-patient/medical-care-report.request";
import { ReSendEpisodReportRequest } from "../../requests/orchestrator-patient/re-send-episode-report.request";

@Injectable({
    providedIn: 'root'
  })
  export class MedicalCareReportService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient) {
      super();
    }

    public getReportPDF(idMedicalCare:number, body:MedicalCareReportRequest): Observable<ReportResponse>{
        let uri = `MedicalCareReport/idMedicalCare/${idMedicalCare}`
    
        return this.httpClient.post<ReportResponse>(environment.urlApiOrchestratorPatient + uri,body ,this.addHeaderToken())
        .pipe(
          catchError(this.handleError)
        )
    }

    public reSendReportPDF(body: ReSendEpisodReportRequest): Observable<ReportResponse>{
      let uri = `MedicalCareReport`
  
      return this.httpClient.post<ReportResponse>(environment.urlApiOrchestratorPatient + uri, body ,this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}